import { DialogInfoBar } from "@components/common/dialog-info-bar";
import {
  activeMembersSelector,
  fetchingActiveMembersFlagsSelector,
} from "@store/active-members/active-members-selector";
import { useAppSelector } from "@store/store-helper";

interface Props {
  /** Maximum number active members seats in current plan */
  maxNumberOfMembers: number;
}

/** Renders the info bar for active members dialog */
export function ActiveMembersInfoBar({
  maxNumberOfMembers,
}: Props): JSX.Element {
  const { status } = useAppSelector(fetchingActiveMembersFlagsSelector);
  const activeMembers = useAppSelector(activeMembersSelector);

  // If seats available is negative, we show 0
  const seatsAvailable = Math.max(maxNumberOfMembers - activeMembers.length, 0);

  return (
    <DialogInfoBar
      isLoading={status === "pending"}
      items={[
        {
          label: "Active members",
          initialValue: activeMembers.length,
        },
        {
          label: "Seats available",
          initialValue: seatsAvailable,
        },
      ]}
    />
  );
}
